/*
 * File: ui-json.ts
 * File Created: 2024-09-09 09:41:37
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 07:42:14
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    EUITagRuleUnion,
} from "../core";

// @uiJSON: on read convert to object, and on write convert back to JSON string.

@UITag.set()
export class uiJSON extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.TableBodyCell,
        EUITagTarget.FormElement,
        EUITagTarget.FormSubmit,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;
        if (rule == null) return null;
        if (rule == false) return null;

        let moreTags: IUITagMoreTagsUnit[] = [
            /// parse string to object
            {
                tag: "uiConverter",
                rule: (o) => {
                    return typeof o.value === "string"
                        ? JSON.parse(o.value)
                        : o.value ?? null;
                },
            },
            /// convert object back to string
            {
                tag: "uiSubmitConverter",
                rule: (o) => (o.value == null ? o.value : JSON.stringify(o.value)),
            },
        ];

        return {
            specials: {
                moreTags,
            },
        };
    }
}
